<div class="flex flex-col lg:flex-row h-full gap-2 z-0 relative p-2">

  <div [ngClass]="{'lg:w-3/5': showTrips, 'w-full': !showTrips }"
    class="w-full h-full overflow-y-auto p-4 bg-white dark:bg-zinc-950">
    <div
      class="p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">

      <form [formGroup]="billForm" (ngSubmit)="onSave()">
        <div class="flex justify-between items-center">
          <h1 class="heading">
            {{ billId ? 'Edit' : 'Add' }}
          </h1>
          <div class="flex gap-2">
            <button type="button" (click)="showTrips = !showTrips" class="btn btn-secondary btn-sm">
              {{ showTrips ? 'Hide Trips' : 'Show Trips' }}
            </button>
          </div>
        </div>

        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />

        <section class="grid gap-4 sm:grid-cols-2">
          <ng-container formGroupName="VendorRef">
            <div class="space-y-1">
              <label class="subheading">Vendor</label>
              <div>
                <ng-select formControlName="value" id="vendor" (change)="onChangeVendor($event)"
                  [notFoundText]="'No record found'" placeholder="Select a vendor" [clearable]="false"
                  [searchable]="true">
                  <ng-option value="" disabled>Select a vendor</ng-option>
                  <ng-option *ngFor="let vendor of vendors" [value]="vendor.Id">
                    {{ vendor.DisplayName | titlecase }}
                  </ng-option>
                </ng-select>
              </div>

              <div *ngIf="submitted && billForm.get('VendorRef.value')?.errors">
                <p *ngIf="billForm.get('VendorRef.value')?.errors?.['required']" class="pt-1 text-red-600 text-xs">
                  Vendor is required
                </p>
              </div>
            </div>
          </ng-container>

          <div class="space-y-1">
            <label class="subheading">
              Due Date
            </label>
            <div class="flex flex-1 gap-2">
              <div class="flex-1">
                <input type="text" name="dueDate" id="dueDate" formControlName="DueDate" [owlDateTime]="DueDate"
                  [owlDateTimeTrigger]="DueDate" />
                <owl-date-time [pickerType]="'calendar'" (afterPickerClosed)="onDateChange(billForm.get('DueDate'))"
                  #DueDate></owl-date-time>
              </div>
            </div>
          </div>
        </section>

        <h2 class="subheading mt-4">
          Billing
        </h2>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <section class="grid gap-4 sm:grid-cols-2">
          <ng-container formGroupName="BillEmail">
            <div class="space-y-1">
              <label class="subheading">
                Email
              </label>
              <div>
                <input formControlName="Address" name="Address" id="billEmail" type="text" />
                <div *ngIf="submitted && billForm.get('BillEmail.Address')?.errors">
                  <p *ngIf="billForm.get('BillEmail.Address')?.errors?.['email']" class="pt-1 text-red-600 text-xs">
                    Valid Email is required
                  </p>
                </div>
              </div>
            </div>
          </ng-container>
        </section>

        <h2 class="subheading mt-4">
          Reference
        </h2>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <section class="grid gap-4 sm:grid-cols-2" formGroupName="reference">
          <div class="space-y-1">
            <label class="subheading">
              Name
            </label>
            <div>
              <input formControlName="name" name="referenceName" id="referenceName" type="text" />
            </div>
          </div>
          <div class="space-y-1">
            <label class="subheading">
              ID
            </label>
            <div>
              <input formControlName="id" name="referenceId" id="referenceId" type="text" />
            </div>
          </div>
        </section>

        <div class="flex justify-between items-center mt-4">
          <h2 class="subheading">
            Line Items
          </h2>
          <div>
            <button *ngIf="lineItems && lineItems.length" type="button" (click)="clearAllLineItems()" class="btn btn-danger text-xs">
              Clear
            </button>
          </div>
        </div>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />

        <section *ngIf="lineItems">
          <div class="max-h-[28rem] overflow-y-auto overflow-x-auto rounded-t-md">
          <table class="min-w-full border border-zinc-300 dark:border-zinc-700 rounded-md bg-white dark:bg-zinc-900">
            <thead class="bg-zinc-100 dark:bg-zinc-800">
              <tr class="text-zinc-800 dark:text-zinc-200">
                <th class="p-2 text-left font-semibold text-sm-dark">#</th>
                <th class="p-2 text-left font-semibold text-sm-dark">Type</th>
                <th class="p-2 text-left font-semibold text-sm-dark">Product/Service</th>
                <th class="p-2 text-left font-semibold text-sm-dark">SKU</th>
                <th class="p-2 text-left font-semibold text-sm-dark">Description</th>
                <th class="p-2 text-left font-semibold text-sm-dark">Qty</th>
                <th class="p-2 text-left font-semibold text-sm-dark">Rate</th>
                <th class="p-2 text-left font-semibold text-sm-dark">Amount</th>
                <th class="p-2 text-center font-semibold text-sm-dark">Action</th>
              </tr>
            </thead>
            <tbody formArrayName="Line">
              <tr *ngFor="let item of lineItems.controls; let i = index" [formGroupName]="i"
                class="border-t border-zinc-200 dark:border-zinc-700 text-zinc-800 dark:text-zinc-100 bg-white dark:bg-zinc-900">
                <td class="p-2 text-zinc-500 dark:text-zinc-400">{{ i + 1 }}</td>
                <td class="p-2 w-40">
                  <select formControlName="DetailType"
                    class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-zinc-300 dark:border-zinc-700 text-zinc-800 dark:text-zinc-100">
                    <option value="ItemBasedExpenseLineDetail" disabled>Normal</option>
                    <option [value]="LineItemType.DESCRIPTION_ONLY" disabled>Description Only</option>
                  </select>
                </td>
                <td class="p-2">
                  <ng-container formGroupName="ItemBasedExpenseLineDetail">
                    <ng-container formGroupName="ItemRef">
                      <select formControlName="value" (change)="onSelectItem($event, i)"
                        class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-zinc-300 dark:border-zinc-700 text-zinc-800 dark:text-zinc-100">
                        <option value="" disabled>Select Service</option>
                        <option *ngFor="let product of productItems" [value]="'' + product.Id">
                          {{ product.Name | titlecase }}
                        </option>
                      </select>
                    </ng-container>
                  </ng-container>
                </td>
                <td class="p-2">
                  <div [ariaReadOnly]="true"
                    class="border rounded-md p-2 w-full h-full bg-zinc-50 dark:bg-zinc-800 border-zinc-300 dark:border-zinc-700 text-zinc-800 dark:text-zinc-100">
                    <span *ngIf="preProductItems">
                      {{
                      item.get('ItemBasedExpenseLineDetail.ItemRef.value')?.value &&
                      preProductItems[item.get('ItemBasedExpenseLineDetail.ItemRef.value')?.value]?.Sku || '0'
                      }}
                    </span>
                  </div>
                </td>
                <td class="p-2">
                  <textarea formControlName="Description" placeholder="Description" type="text"
                    class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-zinc-300 dark:border-zinc-700 text-zinc-800 dark:text-zinc-100"></textarea>
                  <div *ngIf="submitted && item.get('Description')?.errors">
                    <p class="pt-1 text-red-600 dark:text-red-400 text-xs">Description is required</p>
                  </div>
                </td>
                <td class="p-2">
                  <ng-container formGroupName="ItemBasedExpenseLineDetail">
                    <input formControlName="Qty" placeholder="Qty" type="number" (input)="onQtyChange(i)"
                      class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-zinc-300 dark:border-zinc-700 text-zinc-800 dark:text-zinc-100" />
                  </ng-container>
                </td>
                <td class="p-2">
                  <ng-container formGroupName="ItemBasedExpenseLineDetail">
                    <input formControlName="UnitPrice" placeholder="Rate" type="number" (input)="onQtyChange(i)"
                      class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-zinc-300 dark:border-zinc-700 text-zinc-800 dark:text-zinc-100" />
                  </ng-container>
                </td>
                <td class="p-2">
                  <input formControlName="Amount" [readOnly]="true" placeholder="Amount" type="number"
                    class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-zinc-300 dark:border-zinc-700 text-zinc-800 dark:text-zinc-100" />
                  <div *ngIf="submitted && item.get('Amount')?.errors">
                    <p class="pt-1 text-red-600 dark:text-red-400 text-xs">Amount must be greater than 0</p>
                  </div>
                  <div *ngIf="submitted && item.get('ItemBasedExpenseLineDetail.ItemRef.value')?.errors">
                    <p class="pt-1 text-red-600 dark:text-red-400 text-xs">Product/Service is required</p>
                  </div>
                </td>
                <td class="p-2 text-center">
                  <span (click)="removeLineItem(i)">
                    <svg xmlns="http://www.w3.org/2000/svg"
                      class="inline-block size-5 ml-2 text-red-500 hover:text-red-400 transition" viewBox="0 0 14 14">
                      <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        d="M1 3.5h12m-10.5 0h9v9a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-9h0Zm2 0V3a2.5 2.5 0 0 1 5 0v.5m-4 2V11m3-5.5V11" />
                    </svg>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          </div>

          <!-- Trip summary for the line items above -->
          <div *ngIf="selectedTrips?.length"
            class="flex flex-wrap items-center justify-end gap-x-8 gap-y-2 rounded-b-md border border-t-0 border-zinc-300 dark:border-zinc-700 bg-zinc-50 dark:bg-zinc-900 px-4 py-2">
            <div class="flex items-center gap-2">
              <span class="text-sm-light">Trips</span>
              <span class="text-sm-dark font-semibold">{{ selectedTrips.length }}</span>
            </div>
            <div class="flex items-center gap-2">
              <span class="text-sm-light">Total Amount</span>
              <span class="text-base font-semibold text-primary">${{ selectedTripsTotal | number:'1.2-2' }}</span>
            </div>
          </div>

          <h2 class="subheading mt-8">Add</h2>

          <table class="min-w-full mt-1 border border-zinc-300 dark:border-zinc-700 rounded-md bg-zinc-50 dark:bg-zinc-900">
            <thead class="bg-zinc-100 dark:bg-zinc-800">
              <tr class="text-zinc-800 dark:text-zinc-200">
                <th class="p-2 text-left font-semibold text-sm-dark">Type</th>
                <th class="p-2 text-left font-semibold text-sm-dark">Product/Service</th>
                <th class="p-2 text-left font-semibold text-sm-dark">SKU</th>
                <th class="p-2 text-left font-semibold text-sm-dark">Description</th>
                <th class="p-2 text-left font-semibold text-sm-dark">Qty</th>
                <th class="p-2 text-left font-semibold text-sm-dark">Rate</th>
                <th class="p-2 text-left font-semibold text-sm-dark">Amount</th>
                <th class="p-2 text-center font-semibold text-sm-dark">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr [formGroup]="billItemForm"
                class="border-t border-zinc-200 dark:border-zinc-700 text-zinc-800 dark:text-zinc-100">
                <td class="p-2 w-40">
                  <select formControlName="DetailType" (change)="onSelectType($event)"
                    class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-zinc-300 dark:border-zinc-700 text-zinc-800 dark:text-zinc-100">
                    <option value="ItemBasedExpenseLineDetail">Normal</option>
                    <option [value]="LineItemType.DESCRIPTION_ONLY">Description Only</option>
                  </select>
                </td>
                <td class="p-2">
                  <ng-container formGroupName="ItemBasedExpenseLineDetail">
                    <ng-container formGroupName="ItemRef">
                      <select formControlName="value" (change)="onSelectService($event)"
                        class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-zinc-300 dark:border-zinc-700 text-zinc-800 dark:text-zinc-100">
                        <option value="">Select Service</option>
                        <option *ngFor="let product of productItems" [value]="'' + product.Id">
                          {{ product.Name | titlecase }}
                        </option>
                      </select>
                      <div *ngIf="lineItemFormSubmitted && billItemForm.get('ItemBasedExpenseLineDetail.ItemRef.value')?.errors">
                        <p class="pt-1 text-red-600 dark:text-red-400 text-xs">Service is required</p>
                      </div>
                    </ng-container>
                  </ng-container>
                </td>
                <td class="p-2">
                  <div [ariaReadOnly]="true"
                    class="border rounded-md p-2 w-full h-full bg-zinc-50 dark:bg-zinc-800 border-zinc-300 dark:border-zinc-700 text-zinc-800 dark:text-zinc-100">
                    <span *ngIf="preProductItems">
                      {{
                      billItemForm.get('ItemBasedExpenseLineDetail.ItemRef.value')?.value &&
                      preProductItems[billItemForm.get('ItemBasedExpenseLineDetail.ItemRef.value')?.value]?.Sku || '0'
                      }}
                    </span>
                  </div>
                </td>
                <td class="p-2">
                  <textarea formControlName="Description" placeholder="Description" type="text"
                    class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-zinc-300 dark:border-zinc-700 text-zinc-800 dark:text-zinc-100"></textarea>
                  <div *ngIf="lineItemFormSubmitted && billItemForm.get('Description')?.errors">
                    <p class="pt-1 text-red-600 dark:text-red-400 text-xs">Description is required</p>
                  </div>
                </td>
                <td class="p-2">
                  <ng-container formGroupName="ItemBasedExpenseLineDetail">
                    <input formControlName="Qty" placeholder="Qty" type="number"
                      class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-zinc-300 dark:border-zinc-700 text-zinc-800 dark:text-zinc-100" />
                    <div *ngIf="lineItemFormSubmitted && billItemForm.get('ItemBasedExpenseLineDetail.Qty')?.errors">
                      <p class="pt-1 text-red-600 dark:text-red-400 text-xs">Qty is required</p>
                    </div>
                  </ng-container>
                </td>
                <td class="p-2">
                  <ng-container formGroupName="ItemBasedExpenseLineDetail">
                    <input formControlName="UnitPrice" placeholder="Rate" type="number"
                      class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-zinc-300 dark:border-zinc-700 text-zinc-800 dark:text-zinc-100" />
                    <div *ngIf="lineItemFormSubmitted && billItemForm.get('ItemBasedExpenseLineDetail.UnitPrice')?.errors">
                      <p class="pt-1 text-red-600 dark:text-red-400 text-xs">Rate is required</p>
                    </div>
                  </ng-container>
                </td>
                <td class="p-2">
                  <input formControlName="Amount" [readOnly]="true" placeholder="Amount" type="text"
                    class="border rounded-md p-2 w-full bg-white dark:bg-zinc-800 border-zinc-300 dark:border-zinc-700 text-zinc-800 dark:text-zinc-100" />
                  <div *ngIf="lineItemFormSubmitted && billItemForm.get('Amount')?.errors">
                    <p class="pt-1 text-red-600 dark:text-red-400 text-xs">Amount is required</p>
                  </div>
                </td>
                <td class="p-2 text-center">
                  <button (click)="addLineItem()" type="button" class="btn btn-secondary">
                    Add
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="submitted && billForm.get('Line')?.errors" class="flex justify-end mt-2">
            <p class="pt-1 text-red-600 dark:text-red-400 text-xs">Please add at least one Product/Service</p>
          </div>
        </section>

        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />

        <section class="flex justify-end gap-4">
          <button type="submit" class="btn btn-secondary">
            {{ billId ? 'Update' : 'Create' }}
          </button>
        </section>
      </form>
    </div>
  </div>

  <app-invoice-trips [ngClass]="{ 'hidden': !showTrips }" class="w-full lg:w-2/5 h-full flex flex-col border-l border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-950"
    [type]="'company'"
    [companies]="companies"
    (onSelectTrips)="onSelectTrips($event)"
    (viewTripDetails)="openTripDetailsModal($event)"
  ></app-invoice-trips>
</div>

<app-trip-detail-modal *ngIf="tripId" [tripId]="tripId" [source]="'trips'"
  (closeModal)="tripId = null"></app-trip-detail-modal>
